import dataLayer from './dataLayer'

function onTrackRelatedItemsClick (data) {
  dataLayer.add({
    event: 'recipeCollectionSelect',
    linkName: data.item.text,
    linkUrl: !/^https?:\/\//i.test(data.item.url) ? window.location.origin + data.item.url : data.item.url,
    listName: 'Sökförslag',
    listLength: String(data.itemsListLength),
    listItemIndex: String(data.index)
  })
}

function onTrackRelatedItemsShowmore () {
  dataLayer.add({
    event: 'recipeCollectionShowMore',
    linkName: 'visa fler'
  })
}

export default {
  onTrackRelatedItemsClick,
  onTrackRelatedItemsShowmore
}
